import useEditorDispatch from "./useEditorDispatch";
import useFigurePanelId from "./useFigurePanelId";
import { useDispatch } from 'react-redux';
import { useContext } from 'react';
import A from './ActionCreators';
import G from './Getters';
import usePresentSelector from './usePresentSelector';
import { CellDragEnteredContext } from './CellDragEnteredProvider';

export default function DropCell({rowIndex, colIndex, length, structure, 
  

  cropIdsBeingDragged,
  setCropIdsBeingDragged
}){

  const figurePanelId = useFigurePanelId();
  const editorDispatch = useEditorDispatch();


  const { cellDragEntered, setCellDragEntered } = useContext(CellDragEnteredContext);



  if(!figurePanelId){
    throw Error("DropCell requires prop `figurePanelId`");
  }

  

  let dispatch = useDispatch();

  let figurePanel = usePresentSelector(state => G.getFigurePanel(state,{figurePanelId}));

  let numRows = figurePanel.grid.length;


  if( length < 0 ){
    return null;
  }


  const onDrop = (e) => {

    console.log("ON DROP DROP-CELL");

    if( cropIdsBeingDragged.length === 0 ){
      return;
    }

    let targetRowIndex = Math.ceil(rowIndex);
    let rowValues = Object.fromEntries(cropIdsBeingDragged.map((value,ii) => {
      let key = ii+targetRowIndex;
      let objVal = {columnIndices:[colIndex],groupValues:[{value}]};
      return ([key,objVal])
    }))
    ;

    let insertRowsArgs = {
      figurePanelId,
      addExtraRowAbove:(numRows===0),
      rowIndex:Math.ceil(rowIndex),
      rowValues,
      structure:structure,
    }

    let action = A.insertRows(insertRowsArgs);
    dispatch(action);
    setCropIdsBeingDragged([]);

  }

  let [enteredRow, enteredCol] = cellDragEntered;

  let isDragEntered = rowIndex === enteredRow && enteredCol === colIndex;

  return <td
    onMouseEnter={() => { setCellDragEntered([rowIndex,colIndex]) }}
    
    //onClick={onDrop}
    onMouseUp={onDrop}
    
    class={isDragEntered ? "selected" : ""}
    colSpan={length}>

    <div style={{
      padding:3,
      border: '2px dashed #ddd',
      textAlign:'center',
      fontWeight:'bold',
      color:'#dfdfdf',
    }}>
    +
    </div>
    </td>

}
